import { useCallback } from "react";
import { useAuth } from "react-oidc-context";
import { AUTH_BYPASS } from "./dev-bypass";

export function useAuthToken() {
	const auth = useAuth();

	// Null means "send no Authorization header" — the API's bypass only engages for requests it
	// sees as unauthenticated, so a placeholder token would be rejected rather than ignored.
	const getToken = useCallback(async (): Promise<string | null> => {
		if (AUTH_BYPASS) {
			return null;
		}

		if (auth.isLoading) {
			throw new Error("Auth is loading");
		}

		if (!auth.isAuthenticated) {
			await auth.signinRedirect();
			throw new Error("Redirecting to login");
		}

		// react-oidc-context keeps the access token fresh via automaticSilentRenew.
		const token = auth.user?.access_token;
		if (!token) {
			// Token missing despite being authenticated — force a new sign-in.
			await auth.signinRedirect();
			throw new Error("Redirecting to login");
		}

		return token;
	}, [auth]);

	return { getToken };
}
